import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { toast } from '@livable/saas-react-components';
import { Alert, Button, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from '../styles';
export const VoidRefundForm = observer(_ref => {
  let triggerRefresh = _ref.triggerRefresh,
    setTriggerRefresh = _ref.setTriggerRefresh;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    clicked = _useState2[0],
    setClicked = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    reason = _useState4[0],
    setReason = _useState4[1];
  const voidTransaction = async data => {
    const resp = await store.transaction.voidTransactionAsync.run(data);
    return resp;
  };
  const handleClick = () => setClicked(true);
  useEffect(() => {
    if (!clicked) return;
    toast('loading', {
      body: ['Void transaction in progress...']
    }); // ? i18n

    voidTransaction({
      reason,
      transactionId: store.transaction.transactionId,
      hideFromResidentLedger: false // NOTE: Currently by default false but in future should be added checkbox to control this state
    }).then(resp => {
      if (resp && resp.isSuccessful) toast('success', {
        body: ['Transaction successfully voided']
      }); // ? i18n

      store.transaction.setRefundModalIsOpen(false);
      store.transaction.setVoidTransactionType('');
      store.transaction.setTransactionId('');
    }).then(() => {
      store.transaction.setUpdateData();
    }).finally(() => {
      setTriggerRefresh(!triggerRefresh);
      setClicked(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clicked]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, store.transaction.voidTransactionType === 'CAPPED_UTILITY_CHARGE' ? t('resident_account.capped_utility_charge') : store.transaction.voidTransactionType === 'STATEMENT_CAP_CREDIT' ? t('resident_account.statement_cap_credit') : t('resident_account.void_info')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, store.transaction.voidTransactionType === 'CAPPED_UTILITY_CHARGE' ? t('resident_account.capped_utility_charge_desc') : store.transaction.voidTransactionType === 'STATEMENT_CAP_CREDIT' ? t('resident_account.statement_cap_credit_desc') : t('resident_account.void_info_desc'))), /*#__PURE__*/React.createElement("form", {
    id: "voidRefund"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formFields
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "reason",
    label: t('resident_account.reason'),
    name: "reason",
    onChange: e => {
      if (e.target.value.length <= 255) setReason(e.target.value);
    },
    maxRows: 10,
    multiline: true,
    rows: 2,
    type: "text",
    value: reason,
    variant: "outlined"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", reason.length, "/255)"))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => store.transaction.setRefundModalIsOpen(false),
    'custom-attribute': '462-refund-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.transaction.voidTransactionAsync.inProgress,
    onClick: handleClick,
    variant: "contained",
    'custom-attribute': '463-refund-modal'
  }, t('buttons.confirm'))))))));
});